import { combineReducers } from 'redux';

import { ContactsReducerState, contactsReducer } from '../contact/store/contacts-reducer';
import { CustomersReducerState, customersReducer } from '../customer/store/customer-reducer';
import { SuppliersReducerState, suppliersReducer } from '../supplier/store/supplier-reducer';

export interface ContactsAndOrganizationsReducerState {
    suppliers: SuppliersReducerState;
    contacts: ContactsReducerState;
    customers: CustomersReducerState;
}

export const contactsAndOrganizationsReducer = combineReducers<ContactsAndOrganizationsReducerState>({
    suppliers: suppliersReducer,
    contacts: contactsReducer,
    customers: customersReducer,
});
